export const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Intl.DateTimeFormat("en-GB", options).format(
      new Date(dateString)
    );
  };


  export const changeDate = dateString => {
    const date = new Date(dateString);
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  };

  export const capitalizeFirstLetter = (str) => str?.charAt(0).toUpperCase() + str?.slice(1);

  export const formatCount = (value = 0) =>
    new Intl.NumberFormat('en', { notation: 'compact', compactDisplay: 'short' }).format(value);

 export const transformJoinDataToChart = (data = []) => {
  const monthNames = [
    "", // to match index with month numbers (1-based)
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const labels = data.map((item) => monthNames[item.month] || `M${item.month}`);
  const values = data.map((item) => item.userCount ?? 0);

  return {
    labels,
    datasets: {
      label: "Users Joined",
      data: values
    }
  };
};

export const transformGenderRatioData = (data) => {
  const labels = [];
  const userCounts = [];

  // Process each item in the data
  data.forEach(item => {
    if (item.gender) {
      // For valid genders
      labels.push(item.gender);
    } else {
      // For null gender (or unspecified gender)
      labels.push("Other");
    }
    userCounts.push(item.userCount);
  });

  return {
    labels: labels, // These will be "Male", "Female", "Other"
    datasets: [
      {
         data: userCounts,
        backgroundColor: [
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          
        ],
        borderColor: [
          'rgba(54, 162, 235, 1)',
          'rgba(255, 99, 132, 1)',
          'rgba(255, 206, 86, 1)',
          
        ],
        borderWidth: 1,
        },
    ],
  };
};

export const transformSubscriptionDataToChart = (data = {}) => {
  const monthlyData = data.monthlySubscriptions || [];
  const labels = monthlyData.map(item => item.month.slice(0, 3));
  const values = monthlyData.map(item => item.count);

  return {
    labels,
    datasets: {
      label: "Subscriptions",
      data: values
    }
  };
};
